<template>
  <iframe src="https://bot.sanjuan.gob.ar/lite/bot-produccion-credito/?m=channel-web&v=Fullscreen&options=%7B%22hideWidget%22%3Atrue%2C%22config%22%3A%7B%22enableReset%22%3Atrue%2C%22enableTranscriptDownload%22%3Atrue%7D%7D" frameborder="0"></iframe>
</template>

<style>
  iframe{
    width: 100%;
    height: 90vh;
  }
</style>